import { breakpoint, Button, Flex } from '@bfa/common-ui';
import { useBreakpoints } from '@bfa/nextjs-common/hooks';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

type Props = {
  primaryOnClick: () => void;
  secondaryOnClick?: () => void;
  primaryLabel: string;
  secondaryLabel?: string | undefined;
  isPrimaryCtaDisabled?: boolean;
};

const RunwayButtonsContainer = styled(Flex)`
  gap: 1.6rem;
  @media only screen and (min-width: ${breakpoint('sm')}) {
    gap: 2.4rem;
  }
`;

const primaryTestId = 'popup-btn-primary';
const secondaryTestId = 'popup-btn-secondary';

const Actions = ({
  primaryLabel,
  secondaryLabel,
  primaryOnClick,
  secondaryOnClick,
  isPrimaryCtaDisabled = false,
}: Props) => {
  const { isXSDown, isXS } = useBreakpoints();

  const [isPrimaryButtonFullWidth, setIsPrimaryButtonFullWidth] =
    useState(false);

  useEffect(
    () => setIsPrimaryButtonFullWidth(isXSDown || isXS),
    [isXSDown, isXS]
  );

  return (
    <RunwayButtonsContainer flexDirection="column" alignItems="center">
      <Button
        main
        medium
        fullWidth={isPrimaryButtonFullWidth}
        onClick={primaryOnClick}
        data-testid={primaryTestId}
        disabled={isPrimaryCtaDisabled}
      >
        {primaryLabel}
      </Button>
      {secondaryLabel ? (
        <Button
          link
          marginX="auto"
          secondary
          medium
          fullWidth
          onClick={secondaryOnClick}
          noPadding
          data-testid={secondaryTestId}
        >
          {secondaryLabel}
        </Button>
      ) : null}
    </RunwayButtonsContainer>
  );
};

export default Actions;
